import { api } from "@/comn";
import { comnUtils } from "@/comn/utils";
import { TFormSchema, TGridSchema } from "@/comn/hooks";
import { ptlEnvs } from "@/tra/tancis/ptli/comn";

/*
 *  Notifice Management Services
 * !== 알림 관리 서비스 ==!
 */

export const BASE = {
    path: `${ptlEnvs.base}/ptl/ntcmgmt`,
    api: `${process.env.REACT_APP_API_PTLI}/api/v1/ptli/intptl/ptl/ntc-mgmt`,
    nodes: [],
};

export const URLS = {
    ptli0801001q: `${BASE.path}/ptli0801001q`, // Notifice History List !==  알림 이력 목록 ==!
    ptli0801002s: `${BASE.path}/ptli0801002s`, // Notifice History Details !==  알림 이력 상세조회 ==!
};

export const APIS = {
    // Check Notifice History List !==  알림 이력 목록 조회 ==!
    getNotiHistList: (data: any, page: number, size: number) => {
        return api.get(`${BASE.api}?page=${page}&size=${size}`, {
            params: comnUtils.toGetParams(data),
        });
    },
    // Notifice Send History details inquiry !== 알림 발송 이력 상세 정보 조회 ==!
    getNotiHistInfo: (notiSendUuid: any) => {
        return api.get(`${BASE.api}/${notiSendUuid}`);
    },
    // Execute Resend !== 알림 재발송 ==!
    executeResend: (data: any) => {
        return api.post(`${BASE.api}/resend`, {
            ...data,
        });
    },
};

export const SF_NOTI_HIST_SRCH: TFormSchema = {
    id: "form_notiHistSrch",
    schema: {
        notiNm: { type: "text", label: "L_ANOCMT" },
        frstRgsrDtmRnge: {
            type: "daterange",
            label: "L_RCPN_DTM",
            start: { name: "sendStrtDt" },
            end: { name: "sendEndDt" },
            rangeButton: 0,
        },
        usrNm: { type: "text", label: "L_RECPT" },
        notiSendStatCd: {
            type: "select",
            label: "L_STTS",
            all: true,
            area: "comnCd",
            comnCd: "PTL0022",
        }
    },
};

export const SG_NOTI_HIST_LIST: TGridSchema = {
    id: "grid_notiHistList",
    options: { pagination: "out", index: true },
    head: [
        { cells: [{ header: "L_NOTI_TP_SETT_VALUE", binding: "notiTpValue", width: "10%" }] },
        { cells: [{ header: "L_ANOCMT", binding: "notiNm", width: "*" }] },
        { cells: [{ header: "L_RECPT", binding: "usrNm", width: "15%" }] },
        { cells: [{ header: "L_STTS", binding: "notiSendStatCd", width: "10%" }] },
        { cells: [{ header: "L_SEND_DTM", binding: "sendDtm", width: "15%" }] },
        { cells: [{ header: "L_RCPN_CFRM_YN", binding: "rcpnCfrmYn", width: "15%" }] },
        { cells: [{ header: "L_SNDR_NM", binding: "sndrNm", width: "10%" }] },
    ],
    body: [
        { cells: [{ binding: "notiTpValue" }] },
        { cells: [{ binding: "notiNm", align: "left" }] },
        { cells: [{ binding: "usrNm", align: "left" }] },
        { cells: [{ binding: "notiSendStatCd", type: "code", area: "comnCd", comnCd: "PTL0022" }] },
        { cells: [{ binding: "sendDtm", type: "datetime" }] },
        { cells: [{ binding: "rcpnCfrmYn" }] },
        { cells: [{ binding: "sndrNm" }] },
    ],
};

export const SF_NOTI_HIST_INFO: TFormSchema = {
    id: "form_notiHistInfo",
    schema: {
        notiNm: { type: "text", label: "L_ANOCMT", controlSize: 10 },
        notiMsgCn: { type: "textarea", label: "L_NOTI_MSG_CN", controlSize: 10, rows: 10 },
        notiTp: { type: "text", label: "L_NOTI_TP_SETT_VALUE" },
        usrNm: { type: "text", label: "L_RECPT" },
        usrEmlAddr: { type: "text", label: "L_USR_EML_ADDR" },
        usrMoblNo: { type: "text", label: "L_USR_MOBL_NO" },
        notiSendStatCd: { type: "code", label: "L_STTS", area: "comnCd", comnCd: "PTL0022" },
        sendDtm: { type: "datetime", label: "L_SEND_DTM" },
        sndrNm: { type: "text", label: "L_SNDR_NM", controlSize: 10 },
        sndrEmlAddr: { type: "text", label: "L_SNDR_EML_ADDR" },
        sndrTelno: { type: "text", label: "L_SNDR_TELNO" },
    }, 
};

interface SettingsMap {
    [key: number]: string;
}

export const SETTINGS_MAP: SettingsMap = {
    1: "SMS",
    2: "E-Mail",
    4: "Push Notification", // 예시로 추가된 설정
    // 필요에 따라 여기에 더 많은 설정을 추가할 수 있습니다.
};
